module.exports = __webpack_public_path__ + "static/family-fb5c7979c40caacd9e80fc4ff6bc2ecc.jpg";